import { fetcher } from '@commenda/utils';
import { BASE_URL, IRequestNewServicesParams } from './types';

export async function requestNewServices(data: IRequestNewServicesParams) {
  try {
    const res = await fetcher(`${BASE_URL}/request-new-service`, {
      method: 'POST',
      body: data,
    });

    return res;
  } catch (err) {
    console.error(err);
    return null;
  }
}
